import {
  ChatInterface,
  ChatRepositoryInterface,
  FilterRequestData,
  ChatReviewFormDataInterface, ChatReviewInterface,
} from '@/services/QC-V2/chat/interfaces';
import { AxiosInstance } from 'axios';

export default class ChatRepository implements ChatRepositoryInterface {
  constructor(
    private axios: AxiosInstance,
  ) {
  }

  public async getChatArchive(filterRequestData?: FilterRequestData): Promise<ChatInterface[]> {
    const url = `/chat-controller-v2/chats/archive?${this.createQueryString(filterRequestData)}`;

    const response = await this.axios.get(url);

    return response.data;
  }

  public async getChatQueue(filterRequestData?: FilterRequestData): Promise<ChatInterface[]> {
    const url = `/chat-controller-v2/chats/queue?${this.createQueryString(filterRequestData)}`;

    const response = await this.axios.get(url);

    return response.data;
  }

  public async getChatById(id: string): Promise<ChatInterface> {
    const response = await this.axios.get(`/chat-controller-v2/chats/${id}`);

    return response.data;
  }

  public async reviewChat(reviews: ChatReviewFormDataInterface[]): Promise<void> {
    const response = await this.axios.post('/chat-controller-v2/reviews', reviews);

    return response.data;
  }

  public async updateChatReview(id: number, review: ChatReviewFormDataInterface): Promise<void> {
    const response = await this.axios.patch(`/chat-controller-v2/reviews/${id}`, review);

    return response.data;
  }

  public async softDeleteReview(id: number): Promise<void> {
    await this.axios.delete(`/chat-controller-v2/reviews/${id}`);
  }

  private createQueryString(filterRequestData?: FilterRequestData): string {
    if (!filterRequestData) {
      return '';
    }

    const parameters = Object.keys(filterRequestData)
      .filter((key) => !!filterRequestData[key])
      .map((key) => `${key}=${filterRequestData[key]}`);

    return parameters.join('&');
  }
}
